import { render, staticRenderFns } from "./JsonImportFormModal.vue?vue&type=template&id=b0da9ace&scoped=true"
import script from "./JsonImportFormModal.vue?vue&type=script&lang=js"
export * from "./JsonImportFormModal.vue?vue&type=script&lang=js"
import style0 from "./JsonImportFormModal.vue?vue&type=style&index=0&id=b0da9ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0da9ace",
  null
  
)

export default component.exports